export default "__VITE_ASSET__gJ4vLCI5__"